<fieldset class="b-input__radio-group" [attr.disabled]="disabled ? 'disabled' : null">
  <legend class="b-input__radio-input-label" [innerHTML]="label" [attr.for]="id"></legend>
  <div class="b-col-item--wrapper b-col-item--wrapper--{{ cols }}{{horizontal? ' b-input__radio-horizontal':'' }}"
    [style.height]="cols > 1 ? height + 'px' : ''">
    <div *ngFor="let option of options; index as i" #radio [attr.title]="getTitle(option)">
      <div>
        <input type="radio" [id]="id + '-' + i" [name]="name" [value]="i" [ngModel]="valueIndex"
          (ngModelChange)="changeIndex($event)" [checked]="i === valueIndex" [attr.disabled]="isOptionDisabled(option)"
          (click)="wClick.emit($event)" (change)="wChange.emit(value)" />
        &nbsp;<label for="{{id + '-' + i}}" (click)="clickIndex(i,option,$event)" [innerHTML]="getLabelAsync(option) | async"></label>
      </div>
    </div>
  </div>
</fieldset>
<!-- </div> -->
<f-facet-info [isError]="true" [text]="error">
  <ng-content select="f-facet[name=error],[facet-error]"></ng-content>
</f-facet-info>
<f-facet-info [text]="info">
  <ng-content select="f-facet[name=info],[facet-info]"></ng-content>
</f-facet-info>